<template>
  <div v-if="!loading">
    <div class="modal-window" :class="{'open': add_attachment_popup_open}" @click="add_attachment_popup_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="add_attachment_popup_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">Add Attachments</h1>
        </div>
        <div class="modal-content">
          <div class="form-group h-full flex flex-col">
            <label>Upload Attachments</label>
            <form :action="`${$aws_upload_url}`" method="post"
                  enctype="multipart/form-data" id="amazon_form">
              <input type="hidden" name="policy" :value="aws_policy">
              <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
              <input type="hidden" name="x-amz-credential" :value="aws_credential">
              <input type="hidden" name="x-amz-date" :value="aws_date">
              <input type="hidden" name="x-amz-signature" :value="aws_signature">
              <input type="hidden" name="acl" value="private">
            </form>
            <vue-dropzone
                ref="fileUploadDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-file-added="fileAddedToDropZone"
                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                :useCustomSlot="true"
            >
              <div>
                <div class="mb-3">
                  DRAG AND DROP FILES
                </div>
                <div class="mb-3">
                  OR
                </div>
                <div>
                  <a class="btn-secondary-outline">
                    Choose files
                  </a>
                </div>
              </div>
            </vue-dropzone>
          </div>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="saveAttachments()">
            Save
          </a>
        </div>
      </div>
    </div>

    <div class="loading-spinner-outer" v-if="saving_file_number > 0">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Uploading file {{ saving_file_number }} of {{ new_attachments.length }}, please wait
        </div>
      </div>
    </div>

    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>

    <div class="loading-spinner-outer" v-if="deleting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Deleting attachment, please wait
        </div>
      </div>
    </div>
        <div class="create-faq-entry-outer-wrapper">
          <div class="create-faq-entry-main">
            <div class="box">
              <div class="box-content">
                <div class="form-group">
                  <label>Question</label>
                  <input class="form-control" v-model="faq.question">
                </div>
                <div class="flex-2xs">
                  <div class="half-width-2xs pr-3-2xs">
                    <div class="form-group">
                      <label>Category</label>
                      <div class="multi-select-input" @click.stop="select_faq_type_dropdown_open = !select_faq_type_dropdown_open" style="min-width:165px;">
                        <div class="multi-select-input-placeholder">
                          Select Category...
                          <div class="dropdown-icon">
                            <i class="fal fa-chevron-down"></i>
                          </div>
                        </div>
                        <div class="multi-select-input-inner" v-show="select_faq_type_dropdown_open">
                          <div class="multi-select-input-group">
                            <h1 class="input-group-title">FAQ Types</h1>
                            <div class="checkboxes">
                              <div class="checkbox level-1" v-for="faq_type in faq_types">
                                <label>
                                  <input type="radio" name="faq_types" :value="faq_type.id" v-model="selected_faq_type">
                                  <span class="checkbox-label">{{ faq_type.label }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="multi-select-input-group mt-1" v-for="faq_type in faq_types" v-show="faq_type.id === selected_faq_type">
                            <h1 class="input-group-title">FAQ Category</h1>
                            <div class="checkboxes">
                              <div class="checkbox level-1" v-for="faq_category in faq_type.faq_categories">
                                <label>
                                  <input type="radio" name="faq_categories" :value="faq_category.id" v-model="faq.faq_category_id">
                                  <span class="checkbox-label">{{ faq_category.label }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="half-width-2xs pl-3-2xs">
                    <div class="form-group">
                      <label>Sort Order</label>
                      <input class="form-control" v-model="faq.sort_order" type="number" min="1">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Answer</label>
                  <wysiwyg v-model="faq.answer"></wysiwyg>
                </div>
                <div class="mt-3">
                  <div class="flex justify-between">
                    <div>
                      <div class="checkboxes _inline">
                        <label class="checkbox">
                          <input type="checkbox" v-model="faq.published">
                          <div class="checkbox-label">Publish Question</div>
                        </label>
                      </div>
                    </div>
                    <div>
                      <a class="btn-primary" @click.prevent="saveFaq()">
                        Save
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="create-faq-entry-sidebar">
            <div class="box">
              <div class="box-content">
                <div class="flex justify-between">
                  <div class="flex flex-col justify-around">
                    <h2>Attached Files</h2>
                  </div>
                  <div class="flex flex-col justify-around">
                    <button class="btn-primary" @click="add_attachment_popup_open = true">
                      Add Attachments
                    </button>
                  </div>
                </div>
                <div class="create-faq-entry-attached-files-list" v-if="faq.faq_attachments.length > 0">
                  <div class="create-faq-entry-attached-files-item" v-for="attachment in faq.faq_attachments">
                    <div>
                      <strong> {{ attachment.label }} </strong>
                    </div>
                    <div class="">
                      <em v-text="attachment.download_url" style="word-break: break-all; font-size: 0.6rem;"></em>
                    </div>
                    <div class="flex justify-between txt-sm">
                      <div class="txt-danger cursor-pointer" @click="deleteAttachment(attachment.id)">Delete</div>
                      <div class="txt-danger cursor-pointer" @click="copyAttachmentUrl(attachment.id)">Copy URL</div>
                    </div>
                    <input type="text" readonly v-model="attachment.download_url" :id="`attachment_url_box_${attachment.id}`"  style="position: absolute; top: -2000px; left: -2000px;">
                  </div>
                </div>
                <div v-else>
                  No attachments
                </div>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';
import Datepicker from 'vuejs-datepicker';

export default {
  props: [
    'aws_policy',
    'aws_credential',
    'aws_date',
    'aws_signature',
    'faq_id',
    'adding_new_faq',
    'faq_counts',
  ],
  components: {
    'vue-dropzone': vue2Dropzone,
    'datepicker': Datepicker,
  },
  data() {
    return {
      faq: null,
      add_attachment_popup_open: false,
      loading: true,
      saving: false,
      deleting: false,
      saving_file: false,
      uploaded_file: null,
      new_attachments: [],
      new_attachment_info: [],
      saving_file_number: 0,
      faq_types: [],
      selected_faq_type: 1,
      select_faq_type_dropdown_open: false,
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        uploadMultiple: true,
        addRemoveLinks: true,
      },
    };
  },
  mounted() {
    this.loadFaqTypes();
    this.loadFaq();
  },
  computed: {},
  methods: {
    fileAddedToDropZone(uploadedFile) {
      const extension = uploadedFile.name.replace(/^.*\./, '');
      const original_file_name = uploadedFile.name.replace('.' + extension, '');

      let new_upload = {};

      new_upload.name = original_file_name;
      const filename = 'faq_attachments/' + original_file_name + '_' + Date.now();
      new_upload.filename = filename + '.' + extension;
      new_upload.filetype = uploadedFile.type;
      new_upload.uploaded_file = uploadedFile;
      new_upload.original_file_name = original_file_name;
      new_upload.file_url = filename;

      this.new_attachments.push(new_upload);
      this.new_attachment_info.push({
        original_file_name: original_file_name,
        filename: filename + '.' + extension,
      });
    },
    fileRemovedFromDropZone(file) {
      const extension = file.name.replace(/^.*\./, '');
      const original_file_name = file.name.replace('.' + extension, '');
      this.new_attachments = this.new_attachments.filter(attachment => attachment.original_file_name !== original_file_name);
      this.new_attachment_info = this.new_attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
    },
    deleteAttachment(attachment_id) {
      Swal.fire({
        title: 'Are you sure you want to remove this attachment?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleting = true;
          axios.post('/faqs/deleteAttachment', {
            'faq_attachment_id': attachment_id,
          }).then((response) => {
            this.loadFaq();
            this.deleting = false;
          });
        }
      });
    },
    copyAttachmentUrl(attachment_id) {
      const attachment_url_box = document.getElementById(`attachment_url_box_${attachment_id}`);
      attachment_url_box.select();
      document.execCommand("copy");
    },
    loadFaq: _.debounce(function () {
      axios.post('/faqs/loadFaq', {
        'faq_id': this.faq_id,
      }).then((response) => {
        this.faq = response.data;

        this.$nextTick().then(function () {
          const inputs = document.querySelectorAll('.editr--toolbar .dashboard form input');

          inputs.forEach(function (item) {
            item.addEventListener('click', function(e) {
              e.target.focus()
            }.bind(this))
          });
        });
        this.loading = false;
      });
    }, 250),
    loadFaqTypes: _.debounce(function () {
      axios.post('/faqs/loadFaqTypes').then((response) => {
        this.faq_types = response.data;
      });
    }, 250),
    async saveAttachments() {
      await this.new_attachments.forEach(async (upload, index) => {
        let form_data = new FormData(document.querySelector('#amazon_form'));
        form_data.append('Content-Type', upload.filetype);
        form_data.append('key', upload.filename);
        form_data.append('file', upload.uploaded_file);

        await axios({
          method: 'post',
          url: this.$aws_upload_url,
          data: form_data,
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(async () => {
          if((this.saving_file_number + 1) === this.new_attachments.length) {
            this.saveAttachmentInfo();
          } else {
            this.saving_file_number = this.saving_file_number + 1;
          }

        });
      });

    },
    saveAttachmentInfo() {
      axios.post('/faqs/saveAttachments', {
        faq_id: this.faq.id,
        new_attachment_info: this.new_attachment_info,
      }).then((response) => {
        this.add_attachment_popup_open = false;
        Swal.fire({
          title: 'Attachments Uploaded',
          icon: 'success',
        });

        this.loadFaq();

      });
    },
    saveFaq() {

      this.saving = true;
      const validationErrors = Validate({
        question: this.faq.question,
        answer: this.faq.answer,
        sort_order: this.faq.sort_order,
        faq_category_id: this.faq.faq_category_id,
      }, {
        question: {
          presence: {
            allowEmpty: false,
          },
        },
        answer: {
          presence: {
            allowEmpty: false,
          },
        },
        faq_category_id: {
          presence: {
            allowEmpty: false,
          },
        },
        sort_order: {
          presence: {
            allowEmpty: false,
          },
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: 1
          }
        },
      });

      if (validationErrors) {
        this.saving = false;
        Swal.fire({
          title: 'Unable to save FAQ',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        return;
      }

      axios.post('/faqs/update', {
        faq: this.faq,
      }).then((response) => {

        Swal.fire({
          title: 'FAQ Saved',
          icon: 'success',
        });

        window.location.href = '/faqs/manage';
      });
    },
  },
  watch: {
    'faq.faq_category_id'(newVal, oldVal) {
      if (!this.loading && this.adding_new_faq) {
        let counter = this.faq_counts.find(faq_count => faq_count.category_id === this.faq.faq_category_id);
        if(!counter) {
          counter = {
            max_sort_order: 0,
          }
        }
        this.faq.sort_order = counter.max_sort_order + 1;
      }
    },
  },
};
</script>
